export default __webpack_public_path__ + "static/media/rathinam_technical_campus.349bc57c.png";